import { CONFIG } from '../config.js';

/**
 * Keep <html lang> aligned with the active vue-i18n locale (SPA shells, client nav).
 * SSG HTML already sets lang per locale; this fixes spa.html and any stale document.
 */
export function syncDocumentHtmlLang(localeCode) {
  if (typeof document === 'undefined') return;
  const code =
    localeCode && CONFIG.SUPPORTED_LOCALES.includes(localeCode)
      ? localeCode
      : CONFIG.DEFAULT_LOCALE;
  if (document.documentElement.getAttribute('lang') !== code) {
    document.documentElement.setAttribute('lang', code);
  }
}
